import Loading from './loading'
import AnimateLoad from 'components/common/animate-load'

export default AnimateLoad(Loading)
